import { render, staticRenderFns } from "./wp_card.vue?vue&type=template&id=44692e1c&scoped=true&"
import script from "./wp_card.vue?vue&type=script&lang=js&"
export * from "./wp_card.vue?vue&type=script&lang=js&"
import style0 from "./wp_card.vue?vue&type=style&index=0&id=44692e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44692e1c",
  null
  
)

export default component.exports